import { Form } from "antd"

export const { Item: FormItem } = Form
